import { toast } from "react-toastify";

const apiRequest = async (url, payload, ID) => {
  try {
    const res = await url(ID ? { payload, ID } : payload).unwrap();
    return res;
  } catch (error) {
    console.error('apiRequest', error);
    if (error?.status == 400) {
      toast.error(error?.data?.message);
    } else if (error?.status == 401) {
      // UNAUTHENTICATED ACCESS
      setTimeout(() => {
        localStorage.clear();
        window.location.replace("/");
        window.location.reload();
      }, 1500);
    } else if (error?.status == 500) {
      toast.error("HTTP ERROR 500");
    } else if (error?.data?.message) {
      toast.error(error?.data?.message);
    } else {
      toast.error("SERVER ERROR");
    }

    return {
      error: error.error,
      status: error.status,
      originalStatus: error.originalStatus,
    };
  }
  //   return url(payload)
  //     .unwrap()
  //     .then(res => res)
  //     .catch(error => error);
};

export default apiRequest;
